import { useEffect, useState } from 'react'
import { isSameDay } from '@pogokid/util/datetime'
import { useSchedulerPropsContext } from '../../context/schedulerContext'
import { useMinuteHeight } from '../../hooks/eventHooks'
import { minutesFromStartHour } from '../../helpers/positionCalculations'
import styles from './CurrentTimeIndicator.module.css'

export interface CurrentTimeIndicatorProps {
  weekDayDates: Date[]
}

export function CurrentTimeIndicator({
  weekDayDates,
}: CurrentTimeIndicatorProps) {
  const { week } = useSchedulerPropsContext()
  const minuteHeight = useMinuteHeight()
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    const tick = () => setNow(new Date())
    const interval = window.setInterval(tick, 60_000)
    return () => window.clearInterval(interval)
  }, [])

  const isVisible = weekDayDates.some((date) =>
    isSameDay(date, now)
  )
  if (!isVisible) {
    return null
  }

  const startHour = week?.startHour ?? 0
  const endHour = week?.endHour ?? 23
  const minutesFromStart = minutesFromStartHour(startHour, now)
  // endHour is inclusive — slots run through to the start of the next hour.
  const maxMinutes = (endHour - startHour + 1) * 60
  if (minutesFromStart < 0 || minutesFromStart > maxMinutes) {
    return null
  }

  const top = minutesFromStart * minuteHeight

  return (
    <div
      className={styles.CurrentTimeIndicator}
      style={{ top: `${top}px` }}
      aria-hidden="true"
    />
  )
}
